import React, { useState } from "react";

// Full country list for the dropdown.
const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia","Austria","Azerbaijan",
  "Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan","Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi",
  "Cabo Verde","Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros","Congo (Brazzaville)","Congo (Kinshasa)","Costa Rica","Côte d'Ivoire","Croatia","Cuba","Cyprus","Czechia",
  "Denmark","Djibouti","Dominica","Dominican Republic",
  "Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea","Estonia","Eswatini","Ethiopia",
  "Fiji","Finland","France",
  "Gabon","Gambia","Georgia","Germany","Ghana","Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana",
  "Haiti","Honduras","Hong Kong","Hungary",
  "Iceland","India","Indonesia","Iran","Iraq","Ireland","Israel","Italy",
  "Jamaica","Japan","Jordan",
  "Kazakhstan","Kenya","Kiribati","Kosovo","Kuwait","Kyrgyzstan",
  "Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg",
  "Macau","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands","Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco","Mozambique","Myanmar",
  "Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria","North Korea","North Macedonia","Norway",
  "Oman",
  "Pakistan","Palau","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal",
  "Qatar",
  "Romania","Russia","Rwanda",
  "Saint Kitts and Nevis","Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland","Syria",
  "Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago","Tunisia","Turkey","Turkmenistan","Tuvalu",
  "Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan",
  "Vanuatu","Vatican City","Venezuela","Vietnam",
  "Yemen",
  "Zambia","Zimbabwe",
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const NAVY = "#004d99";

function InterestForm() {
  const [form, setForm] = useState({ email: "", name: "", country: "", school: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    const email = form.email.trim();
    if (!EMAIL_RE.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch("/api/interestSignup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          name: form.name.trim(),
          country: form.country,
          school: form.school.trim(),
        }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || "Something went wrong. Please try again.");
      }
      setDone(true);
    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "13px 14px",
    fontSize: "0.95rem",
    border: "1px solid #d6dee6",
    borderRadius: "10px",
    background: "#fff",
    color: "#1a1a2e",
    boxSizing: "border-box",
    outline: "none",
  };
  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: "#334",
    marginBottom: "6px",
    display: "block",
  };

  return (
    <div style={{ background: "#f8f9fa", padding: "clamp(40px, 8vw, 80px) 0" }}>
      <div className="container">
        <div
          style={{
            maxWidth: "720px",
            margin: "0 auto",
            background: "#fff",
            borderRadius: "20px",
            border: "1px solid #e8eef3",
            boxShadow: "0 8px 30px rgba(0, 77, 153, 0.08)",
            padding: "clamp(24px, 5vw, 44px) clamp(20px, 5vw, 40px)",
          }}
        >
          <p
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: NAVY,
              marginBottom: "10px",
            }}
          >
            Stay in the loop
          </p>
          <h2
            style={{
              fontSize: "clamp(1.5rem, 5.5vw, 2rem)",
              fontWeight: 700,
              color: "#1a1a2e",
              letterSpacing: "-0.02em",
              marginBottom: "12px",
            }}
          >
            Register your interest in future IRO updates
          </h2>
          <p style={{ fontSize: "1.02rem", color: "#555", lineHeight: 1.6, marginBottom: "28px" }}>
            Be the first to hear when registration opens for the next International
            Research Olympiad, along with practice resources and key dates.
          </p>

          {done ? (
            <div
              style={{
                background: "rgba(0, 77, 153, 0.06)",
                border: "1px solid rgba(0, 77, 153, 0.15)",
                borderRadius: "12px",
                padding: "24px",
                textAlign: "center",
              }}
            >
              <p style={{ fontSize: "1.1rem", fontWeight: 600, color: NAVY, margin: "0 0 6px" }}>
                You're on the list 🎉
              </p>
              <p style={{ fontSize: "0.95rem", color: "#555", margin: 0 }}>
                Thanks for registering your interest. We'll be in touch with updates
                about the next IRO.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} noValidate>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                  gap: "18px",
                }}
              >
                <div>
                  <label style={labelStyle} htmlFor="if-email">
                    Email <span style={{ color: "#c0392b" }}>*</span>
                  </label>
                  <input
                    id="if-email"
                    type="email"
                    required
                    autoComplete="email"
                    placeholder="you@example.com"
                    value={form.email}
                    onChange={set("email")}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle} htmlFor="if-name">
                    Full name
                  </label>
                  <input
                    id="if-name"
                    type="text"
                    autoComplete="name"
                    placeholder="Your name"
                    value={form.name}
                    onChange={set("name")}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle} htmlFor="if-country">
                    Country
                  </label>
                  <select
                    id="if-country"
                    value={form.country}
                    onChange={set("country")}
                    style={{ ...inputStyle, appearance: "auto" }}
                  >
                    <option value="">Select your country…</option>
                    {COUNTRIES.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={labelStyle} htmlFor="if-school">
                    School
                  </label>
                  <input
                    id="if-school"
                    type="text"
                    autoComplete="organization"
                    placeholder="Your school"
                    value={form.school}
                    onChange={set("school")}
                    style={inputStyle}
                  />
                </div>
              </div>

              {error && (
                <p style={{ color: "#c0392b", fontSize: "0.9rem", margin: "16px 0 0" }}>
                  {error}
                </p>
              )}

              <button
                type="submit"
                disabled={submitting}
                style={{
                  marginTop: "24px",
                  width: "100%",
                  padding: "15px",
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#fff",
                  background: submitting ? "#6b8cb0" : NAVY,
                  border: "none",
                  borderRadius: "10px",
                  cursor: submitting ? "default" : "pointer",
                  boxShadow: "0 4px 14px rgba(0, 77, 153, 0.3)",
                  transition: "background 0.2s ease",
                }}
              >
                {submitting ? "Submitting…" : "Register my interest"}
              </button>
              <p style={{ fontSize: "0.78rem", color: "#8a94a3", margin: "14px 0 0", textAlign: "center" }}>
                We'll only use your details to send IRO updates. No spam.
              </p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default InterestForm;
